import { render, staticRenderFns } from "./PartsList.vue?vue&type=template&id=8631f074&"
import script from "./PartsList.vue?vue&type=script&lang=js&"
export * from "./PartsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports